import React, { useEffect, useState } from "react";

import bento1 from "../assets/bento1.jpg";
import bento2 from "../assets/bento2.jpg";
import bento3 from "../assets/bento3.jpg";
import bento4 from "../assets/bento4.jpg";
import bento5 from "../assets/bento5.jpg";
import bento6 from "../assets/bento6.jpg";
import bento7 from "../assets/bento7.jpg";
import bento8 from "../assets/bento8.jpg";
import bento9 from "../assets/bento9.jpg";
import bento10 from "../assets/bento10.jpg";
import bento11 from "../assets/01.jpg";
import bento12 from "../assets/02.jpg";
import bento13 from "../assets/03.jpg";
import bento14 from "../assets/04.jpg";
import bento15 from "../assets/05.jpg";
import bento16 from "../assets/10.jpg";
import bento17 from "../assets/11.jpg";
import bento18 from "../assets/12.jpg";
import bento19 from "../assets/13.jpg";
import bento20 from "../assets/14.jpg";

type ImageSet = {
  leftTop: string;
  leftBottom: string;
  center: string;
  rightTop: string;
  rightBottom: string;
};

const IMAGE_SETS: ImageSet[] = [
  { leftTop: bento1,  leftBottom: bento4,  center: bento2,  rightTop: bento3,  rightBottom: bento5 },
  { leftTop: bento6,  leftBottom: bento8,  center: bento7,  rightTop: bento9,  rightBottom: bento10 },
  { leftTop: bento11, leftBottom: bento12, center: bento15, rightTop: bento13, rightBottom: bento14 },
  { leftTop: bento16, leftBottom: bento18, center: bento17, rightTop: bento19, rightBottom: bento20 },
];

// Single image – no card placeholders, no cropping
const BentoImg: React.FC<{ src: string; alt: string }> = ({ src, alt }) => (
  <img
    src={src}
    alt={alt}
    loading="lazy"
    className="w-full h-auto rounded-3xl shadow-[0_18px_45px_rgba(0,0,0,0.18)]"
  />
);

const TimelessLookBento: React.FC = () => {
  const [activeSet, setActiveSet] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  // just the center images for mobile autoplay
  const centerImages = IMAGE_SETS.map((s) => s.center);
  const [mobileIndex, setMobileIndex] = useState(0);

  // breakpoint
  useEffect(() => {
    const onResize = () => {
      if (typeof window === "undefined") return;
      setIsMobile(window.innerWidth < 768);
    };
    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  // autoplay
  useEffect(() => {
    const id = setInterval(() => {
      if (isMobile) {
        setMobileIndex((prev) => (prev + 1) % centerImages.length);
      } else {
        setActiveSet((prev) => (prev + 1) % IMAGE_SETS.length);
      }
    }, 4000);
    return () => clearInterval(id);
  }, [isMobile, centerImages.length]);

  const current = IMAGE_SETS[activeSet];

  return (
    <section className="w-full py-10 sm:py-14 lg:py-16 bg-transparent">
      {/* you can change px here if you want it even wider */}
      <div className="w-full px-4 sm:px-8 lg:px-16 xl:px-24">
        <div className="text-center mb-8 sm:mb-10">
          <h2 className="text-hero font-medium text-[#622935] font-display">
            Timeless Looks
          </h2>
          <div className="mt-2 h-1 w-24 bg-[#622935] mx-auto rounded-full" />
        </div>

        {isMobile ? (
          // MOBILE: only center image, auto-changing
          <div className="w-full max-w-sm mx-auto">
            <BentoImg src={centerImages[mobileIndex]} alt="Timeless look" />
          </div>
        ) : (
          // DESKTOP: 2 + 1 + 2, all columns top-aligned
          <div className="space-y-6">
            <div className="grid grid-cols-[minmax(0,1fr)_minmax(0,1.1fr)_minmax(0,1fr)] gap-8 xl:gap-12 items-start">
              {/* left column */}
              <div className="space-y-6 xl:space-y-8">
                <BentoImg src={current.leftTop} alt="Timeless look left top" />
                <BentoImg src={current.leftBottom} alt="Timeless look left bottom" />
              </div>

              {/* center hero */}
              <div>
                <BentoImg src={current.center} alt="Timeless look center" />
              </div>

              {/* right column */}
              <div className="space-y-6 xl:space-y-8">
                <BentoImg src={current.rightTop} alt="Timeless look right top" />
                <BentoImg src={current.rightBottom} alt="Timeless look right bottom" />
              </div>
            </div>

            {/* set indicators for desktop only */}
            <div className="flex justify-center mt-2 space-x-3">
              {IMAGE_SETS.map((_, idx) => (
                <button
                  key={idx}
                  onClick={() => setActiveSet(idx)}
                  className={`h-2.5 rounded-full transition-all duration-200 ${
                    idx === activeSet ? "w-8 bg-[#622935]" : "w-2.5 bg-gray-300"
                  }`}
                />
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default TimelessLookBento;
